import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowUpLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconArrowUpLeft"><Path fillRule="evenodd" clipRule="evenodd" d="M16 5H5V16H7.5V9.26777L17.75 19.5178L19.5178 17.75L9.26777 7.5H16V5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowUpLeft;
